<template>
  <div :class="classes" class="full-bg-image">
    <div class="template">
      <div class="background-bar"></div>
      <div class="full-image-container">
        <div class="full-image" :style="imageStyles"></div>
      </div>
      <div class="template-content">
        <div class="counter-component stagger-in">
          {{indexValue + 1}} - {{countValue}}
        </div>
        <h1 class="stagger-in" v-html="header"></h1>
        <p class="stagger-in" v-html="main"></p>
        <div class="supp stagger-in"><img :src="suppAsset"/></div>
      </div>
    </div>
  </div>
</template>

<script>
  import { TimelineMax, Power2 } from 'gsap';
  import { mobileLayout } from '../util';
  
  export default {
    name: 'FullBgImage',
    props: {
      header: String,
      main: String,
      supp: String,
      image: String,
      classes: Array,
      index: Number,
      count: Number,
      indexValue: Number,
      countValue: Number,
      finishTransition: Function
    },
    computed: {
      imageStyles: function(){
        return {
          'backgroundImage': 'url(' + this.imageAsset + ')'
        }
      }
    },
    created() {
      this.imageAsset = (this.image != '') ? require('../assets/images/' + this.image) : null
      this.suppAsset = (this.supp != '') ? require('../assets/images/' + this.supp) : null
    },
    methods: {
    	transitionIn: function (dir) {
        // console.log("TRANSITION FUNC FullBgImage");
        let $el = this.$el;
        let bgBar = $el.querySelector('.background-bar')
        let content = $el.querySelector('.template-content');
        let image = $el.querySelector('.full-image-container');
        let imageAsset = $el.querySelector('.full-image');
        let staggerEl = $el.querySelectorAll('.stagger-in');


        let clipFrom = 'rect(0px, 0px, ' + window.innerHeight + 'px, 0px)';
        let clipTo = 'rect(0px, ' + window.innerWidth + 'px, ' + window.innerHeight + 'px, 0px)';


        let contentDelay = mobileLayout() ? 0 : 0.08;

        let tl = new TimelineMax({onComplete: this.transitionInComplete})
        tl
        .set($el, {background: 'transparent'})
        .set(bgBar, {xPercent: -100, scaleX: 1})
        .set(content, {yPercent: 100})
        .set(image, {clip: clipFrom})
        .set(imageAsset, {x: -40})
        .set(staggerEl, {opacity: 0, y: 40})
        .addLabel('start')
        .to(bgBar, 0.6, {xPercent: 0, ease: Power2.easeIn}, 'start')
        .addLabel('wipe')
        .set($el, {background: '#fff'}, 'wipe')
        .to(bgBar, 0.5, {scaleX: .33, ease:Power2.easeOut}, 'wipe')
        .to(content, 0.6, {yPercent: 0, ease:Power2.easeInOut}, 'wipe-=' + contentDelay)
        .to(image, 0.6, {clip: clipTo, ease:Power2.easeOut}, 'wipe')
        .to(imageAsset, 0.8, {x: 0, ease:Power2.easeOut}, 'wipe-=0.12')
        .staggerTo(staggerEl, 0.8, {opacity: 1, y: 0, ease:Power2.easeOut}, 0.1, 'wipe+=0.08')
        .set(image, {clearProps: 'clip'})

        // if(dir == -1){
        //   tl.set(bgBar, {transformOrigin: '0% 50%'}, 'start')
        // }

        let slides = document.querySelectorAll('.slide');
        tl.set(slides, {clearProps: 'opacity'}, 'wipe')

    	},
    	transitionOut: function () {
        let tl2 = new TimelineMax({onComplete: this.transitionOutComplete})

        tl2
        .set(this.$el, {opacity: 1})
    	},
      transitionInComplete: function() {
        // console.log("ENABLE SITE INTERACTIONS")
        this.finishTransition();
      },
      transitionOutComplete: function() {
        // console.log("CLEAN UP SLIDE")
      }
    }
  } 
</script>

<style lang="scss">
  @import '../sass/variables';

  .full-bg-image{
    @media #{$phoneQuery}{
      .template{
        min-height: 100%;
      }
    }
    .background-bar{
      position: absolute;
      right: 0;
      top: 0;
      height: 100%;
      background: linear-gradient(to bottom, $lightpurple 0%,$darkpurple 100%);
      width: 100%;
      transform-origin: 100% 50%;
      // @media #{$phoneQuery}{
      //   height: 60%;
      // }
    }
    .full-image-container{
      width: 100%;
      height: 100%;
      @include vw-pixels((
        'padding': 50,
        'padding-top': 80,
        'padding-bottom': 100
      ));
      position: absolute;
      overflow: hidden;
      .full-image{
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 100%;
      }
      @media #{$phoneQuery}{
        padding-left: 0;
        padding-right: 0;
        padding-top: 15vw;
        .full-image{
          height: 50%;
        }
      }
    }
    .template-content{
      position: absolute;
      width: 45%;
      background: #fff;
      bottom: 0;
      left: 0;
      @include vw-units((
        'height': 28,
        'padding-left': 4.8,
        'padding-right': 4.8,
        'padding-top': 3
      ));
      @media #{$phoneQuery}{
        width: 100%;
        height: auto;
        padding-top: 3vw;
        padding-bottom: 16vw;
        bottom: auto;
        top: 64%;
      }
      h1{
        line-height: 1.1;
        @include vw-pixels((
          'font-size': 45,
          'margin-bottom': 8
        ), 1.5);
        @media #{$phoneQuery}{
          // font-size: 5.6vw;
        }
      }
      p{
        color: $grey;
        font-family: freight-text-pro, serif;
        letter-spacing: 0.01em;
        line-height: 1.3;
        @include vw-pixels((
          'margin-left': 32,
          'font-size': 22
        ), 2);
        @media #{$phoneQuery}{
          margin-left: 0;
          // font-size: 3.2vw;
        }
      }
      .supp{
        @include vw-units((
          'width': 28
        ), 1.3);
        margin-left: 10%;
        margin-top: 4%;
        @media #{$phoneQuery}{
          margin-left: 0;
        }
      }
    }
    img{
      display: block;
      width: 100%;
    }
  }
</style>